// TODO: refactor this component to use fields api
/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    Table
} from "reactstrap";
import useConfig from "../../../../../actions/Tenants/config/configHook";
import { isFilledArray } from "../../../../../utils";
import { useTenantDefectDefinitions } from "../../../../Forms/useManagedOptionsHook";
import { getFruitTableData as getFruitTableDataV2 } from "./FruitTable";

export default function FruitTable({ fruits, check, layer, do_print }) {
    const user = useSelector((state) => state.auth.user);
    const config = useConfig();
    const tenantDefectDefinitions = useTenantDefectDefinitions(layer.fruit_type);

    const [header, rows, footer] = getFruitTableDataLegacy({ layer, check, fruits, config, user, tenantDefectDefinitions });

    return <Table size="sm" responsive={!do_print} borderless={true}>
        <thead>
            <tr>{header.map((i, index) => <th key={index} className="text-muted text-start">{i}</th>)}</tr>
        </thead>
        <tbody>
            {rows.map((i, index) => <tr key={index}>
                {i.map((x, xindex) => <td key={xindex} className="text-capitalize text-start align-middle" >{x.display_component()}</td>)}
            </tr>)}
        </tbody>
        <tbody>
            <tr>
                {footer.map((i, index) => <td key={index} className="fw-bold text-start ">{i}</td>)}
            </tr>
        </tbody>
    </Table >;
}

FruitTable.defaultProps = {
    do_print: false
};
FruitTable.propTypes = {
    check: PropTypes.object,
    layer: PropTypes.object,
    do_print: PropTypes.bool,
    fruits: PropTypes.array
};

// TODO: in september 2026, remove this legacy function and use getFruitTableDataV2 directly in FruitTable and PDF Reports.
export function getFruitTableDataLegacy({ layer, check, fruits, config, user, tenantDefectDefinitions }) {
    const location = config.get_check_type_config(layer, check);

    if (isFilledArray(location?.summary_fruit_fields_v2)) {
        return getFruitTableDataV2({ layer, check, fruits, config, user, tenantDefectDefinitions });
    }
    if (isFilledArray(location?.summary_fruit_fields)) {
        console.error("Using legacy fruit table, please update your check type configuration to use summary_fruit_fields_v2 and migrate your custom summary fields if you have any"); // eslint-disable-line no-console
        return [["Incorrect configuration"], [[{ display_component: () => "-", display_vector: () => null }]], ["-"]];
    }
    console.warn(`No summary_fruit_fields_v2 configuration found for check type ${location?.value}`); // eslint-disable-line no-console
    return [[], [], []];

}

